import { injectable } from 'inversify';
import 'reflect-metadata';
import { Response } from '@/_shared/_api/models/response.model';
import { ERRORS } from '../constants';
import { Subscription } from '../models/subscription/subscription.model';
import { SubscriptionItem } from '../models/subscription-item/subscription-item.model';
import axiosClient from './axios-client';
import { getSession } from 'next-auth/react';
import jwt from 'jsonwebtoken';

@injectable()
export class SubscriptionService {
  async getSubscriptionsByEmail(email: string): Promise<Subscription[]> {
    try {
      const session = await getSession();

      const response = await axiosClient.get<Response<Subscription[]>>(
        `/api/subscriptions/get-subscriptions`,
        {
          params: { email: email },
          headers: {
            CubeAsiaAuthorization: `${jwt.decode(session?.user.cubeAsiaBearer!)}`,
          },
        }
      );

      return response.data as Subscription[];
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getSubscriptionsItems(): Promise<SubscriptionItem[]> {
    try {
      const session = await getSession();

      const response = await axiosClient.get<Response<SubscriptionItem[]>>(
        `/api/subscriptions/get-subscription-items`,
        {
          headers: {
            CubeAsiaAuthorization: `${jwt.decode(
              session?.user.cubeAsiaBearer!
            )}`,
          },
        }
      );

      return response.data as SubscriptionItem[];
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
